import React, {
	Component
} from 'react';
import Global from '../../Global';

import './DataPack.css';
import ThreeLogo from '../../svgs/logo-three-lg.svg';
import icon_en from '../../images/newsimplan-icon-en.png';
import icon_tc from '../../images/newsimplan-icon-tc.png';
import icon02_en from '../../images/newsimplan-icon02-en.png';
import icon02_tc from '../../images/newsimplan-icon02-tc.png';
import icon03_en from '../../images/newsimplan-icon03-en.png';
import icon03_tc from '../../images/newsimplan-icon03-tc.png';
import icon04_en from '../../images/newsimplan-icon04-en.png';
import icon04_tc from '../../images/newsimplan-icon04-tc.png';
import renderHtml from './util/renderHTML';
const iconForDataPack = {
	icon_en: icon_en,
	icon02_en: icon02_en,
	icon03_en: icon03_en,
	icon04_en: icon04_en,
	icon_tc: icon_tc,
	icon02_tc: icon02_tc,
	icon03_tc: icon03_tc,
	icon04_tc: icon04_tc,

}

class DataPack extends Component {

	constructor(props) {
		super(props);

		this.state = {
			data: {
				general: null,
				buttonInfo:null,
				buttonInfo2:null,
				dataPackItems: null
			},
		}

	}

	componentDidMount() {

		var url = Global.getAPI('plan-data-pack');
		fetch(url)
			.then(function (response) {
				if (response.status >= 400) {
					throw new Error('Error API: plan-data-pack');
				}
				return response.json();
			})
			.then(data => this.setState({
				data
			}));
	}

	getNewSimPlanImagePath(name, lang = 'en') {
		let prefix = 'newsimplan-icon-en'
		// return `../../images/${prefix}-${name}-${lang}.png`;
		// `/static/media/living-color.870877c3.jpg`
		return iconForDataPack[`${name}_${lang}`];
	}

	getAPIJson(){
		return this.state.data;
	}

	dataPackImage(name){
		if( Object.keys(iconForDataPack).findIndex(e=>e==name)>=0)
			return this.getNewSimPlanImagePath(name, window.THREE_REACT_APP_GLOBAL.language || '')
		else
			return name;
	}

	getLeftButton(){
		let html = '';
		if(this.state.data.buttonInfo.control === "ON"){

		    let colClass = this.state.data.buttonInfo2.control === "ON" ? "col-xs-6" : "col-xs-12";
		    let textAlign = this.state.data.buttonInfo2.control === "ON" ? "right" : "center";

			html = (
                <div className={colClass}>
                    <div className="button-block" style={{textAlign}}>
                        <a href={this.state.data.buttonInfo.link}>
                            {this.state.data.buttonInfo.label}
                        </a>
                    </div>
                </div>
			)
		}
		return html
	}

	getRightButton(){
    		let html = '';
    		if(this.state.data.buttonInfo2.control === "ON"){

                let colClass = this.state.data.buttonInfo2.control === "ON" ? "col-xs-6" : "col-xs-12";
                let textAlign = this.state.data.buttonInfo2.control === "ON" ? "left" : "center";

    			html = (
                    <div className={colClass}>
                        <div className="button-block" style={{textAlign}}>
                            <a href={this.state.data.buttonInfo2.link}>
                                {this.state.data.buttonInfo2.label}
                            </a>
                        </div>
                    </div>
    			)
    		}
        return html
    }

	render() {
		if (this.state.data.general && this.state.data.dataPackItems) {
			let dataPackItems = this.getAPIJson().dataPackItems;
			let general = this.getAPIJson().general;
			let bgcolor = dataPackItems.map(_ => _.color).join(',');
			// hard code return
			return <div id="data-pack" className='data-pack container clearfix'>
				<div className="clearfix">
					<div className="col-xs-12 pack">
						<a id='data-top-up' href='#data-top-up'>data-top-up</a>
						<h2>{general.headline}</h2>
						<div className="bardesc-block">
						</div>
						<div className="bardesc-block">
							<div className="barcolor"
								 style={{
									 backgroundImage: `linear-gradient(to right, ${bgcolor}) `
								 }}
							>
								<div className={"flex"}>

									<div className="w50p bardesc no-float-left">
										{general.high}
									</div>
									<div className="w50p bardesc no-float-right">
										{general.irregular}
									</div>
								</div>
							</div>
						</div>
						<div className="data-card">
							<div className="card-container">
								<div className="card-table">
									<div className="card-row hardcode">
										{[dataPackItems].map((itemRow, index) => {
											const items = itemRow.map((item, index) => {
												return [
													<div className="card-content clearfix" key={index}>

														<div className="card clearfix">
															<div className="top">
																<div className="img" style={{ backgroundImage: `url(${this.dataPackImage(item.img)}) `}} />
															</div>
															<div className="text">
																<div className="headline" style={{ color: item.color }}>
																	{item.headline}
																</div>
																<div className="desclist flex-re">
																	{item.more &&
																	<div className="desc-block">
																		<div className="desc">{renderHtml(item.moreDetail.text)}</div>
																	</div>
																	}
																	<div className="desc-block">
																		<div className="desc">{renderHtml(item.text)}</div>
																	</div>
																</div>
															</div>
															<div className="ctalist flex-re">
																{item.more &&
																<div className="link">
																	<a href={item.moreDetail.link} className="cta">{item.moreDetail.label}</a>
																</div>
																}

																<div className="link">
																	<a href={item.link} className="cta">{item.label}</a>
																</div>
															</div>
														</div>
													</div>,
												]
											})
											// if(document.body.offsetWidth <= 480){
											// 	return items;
											// }
											// else{
											return <div className="card-inner" key={index}>
												{items}
											</div>
											// }
										})
										}
									</div>
								</div>
							</div>
						</div>

						<div className="row">
                            {this.getLeftButton()}
                            {this.getRightButton()}
						</div>
					</div>
				</div>
			</div>

		} else {
			return null;
		}

	}

}


export default DataPack;